import { render, staticRenderFns } from "./CommonProblemModal.vue?vue&type=template&id=0384e6b8&scoped=true&"
import script from "./CommonProblemModal.vue?vue&type=script&lang=js&"
export * from "./CommonProblemModal.vue?vue&type=script&lang=js&"
import style0 from "./CommonProblemModal.vue?vue&type=style&index=0&id=0384e6b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0384e6b8",
  null
  
)

export default component.exports